<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { ADDON_GROUP } from '@/common/constants';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { get, orderBy } from 'lodash';

export default {
  name: 'ZoomDocsAddon',
  mixins: [base, planCommon, addonCustomSelect],
  group() {
    return [ADDON_GROUP.WIN_BACK];
  },
  computed:{
    lowestPlan() {
      const list = orderBy(
        this.planMapFlat.filter((p) => p.type === this.planType),
        ['amount'],
        'asc',
      );
      return get(list, [0], {});
    },
  }
};
</script>
